import React from 'react'
import { View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text, Button, Icon } from '@components/base'

interface NoSensorViewProps {
  onActivateSensorPress(): void
  activateDisabled: boolean
}

export const NoSensorView = ({ onActivateSensorPress, activateDisabled }: NoSensorViewProps) => {
  const styles = useStyleSheet(themedStyle)
  const insets = useSafeAreaInsets()

  return (
    <View style={[styles.container, { paddingBottom: insets.bottom + 16 }]}>
      <View style={styles.mainContent}>
        <Icon name="circle-dashed" weight="thin" style={styles.icon} />
        <Text type="regular" style={styles.text}>
          You do not have an active sensor.
        </Text>
      </View>
      <View style={styles.buttonsContainer}>
        <Button
          type="primary"
          size="block"
          onPress={onActivateSensorPress}
          disabled={activateDisabled}
          accessibilityLabel="Integrate new sensor"
        >
          Integrate New Sensor
        </Button>
      </View>
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    flexGrow: 1,
    justifyContent: 'space-between',
    backgroundColor: 'theme.background',
  },
  mainContent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    marginHorizontal: 48,
    textAlign: 'center',
  },
  icon: {
    width: 80,
    height: 80,
    marginBottom: 32,
    color: 'theme.text.primary',
  },
  buttonsContainer: {
    marginTop: 24,
    marginHorizontal: 16,
  },
})
